const getters = {
  activeIndex: state => state.common.activeIndex,
  menuFresh: state => state.common.menuFresh,
  product: state => state.common.product
}

export default getters;